<div class="mat-typography mat-body mat-app-background parent-container">
  <h1>Application Submitted Confirmation</h1>
  <span>Your application has been submitted. @if (confirmationNum) {
    Please note the Payment Confirmation Number.
  } A summary of your payment requirements is detailed below.</span>
  <h2>Application Submitted on: {{timeStamp}}</h2>
  @if (confirmationNum) {
    <h2>Payment Confirmation Number: {{confirmationNum}}</h2>
  }

  <div class="dynamic-payment-data">
    @for (field of paymentTypeInfo; track $index) {
      <p>
        <span class="bold-me">{{field.label}}:</span><br/><span [innerHTML]=field.value></span>
      </p>
    }
  </div>

  <div>
    <span>{{thankYou}}</span>
  </div>
</div>
